export default __webpack_public_path__ + "static/media/gm-pt-girl.149aa938.webp";